import type {
  NumberFieldProps as AriaNumberFieldProps,
  ButtonProps,
  ValidationResult,
} from "react-aria-components";

import { ChevronDown, ChevronUp } from "lucide-react";
import { Group } from "react-aria-components";
import { NumberField as AriaNumberField, Button } from "react-aria-components";
import { twMerge } from "tailwind-merge";

import { Description, FieldError, Input, Label } from "@/components/field";

import { composeTailwindRenderProps } from "../utils";

export interface NumberFieldProps extends AriaNumberFieldProps {
  description?: string;
  errorMessage?: ((validation: ValidationResult) => string) | string;
  label?: string;
}

export function NumberField({
  description,
  errorMessage,
  label,
  ...props
}: NumberFieldProps) {
  return (
    <AriaNumberField
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "group flex flex-col gap-1",
      )}
    >
      <Label>{label}</Label>
      <Group className="flex relative">
        {() => (
          <>
            <Input className="pr-8" />
            <div
              className={twMerge(
                "absolute right-0 top-0 bottom-0 flex flex-col border-l border-border-brand",
              )}
            >
              <StepperButton className="rounded-tr-md" slot="increment">
                <ChevronUp aria-hidden className="w-4 h-4" />
              </StepperButton>
              <div className="h-px bg-border-brand" />
              <StepperButton className="rounded-br-md" slot="decrement">
                <ChevronDown aria-hidden className="w-4 h-4" />
              </StepperButton>
            </div>
          </>
        )}
      </Group>
      {description && <Description>{description}</Description>}
      <FieldError>{errorMessage}</FieldError>
    </AriaNumberField>
  );
}

function StepperButton({
  className,
  ...props
}: { className: string } & ButtonProps) {
  return (
    <Button
      {...props}
      className={twMerge(
        "px-1 py-0.5 cursor-pointer flex-1 text-text-primary hover:bg-button-primary-bg hover:text-button-primary-fg",
        className,
      )}
    />
  );
}
